<template>
  <!-- <div :class="['tr-details', { 'disabled':!isEditable }]"> -->
  <div>
    <v-container>
      <v-row class="px-5">
        <v-col cols="12" md="4" sm="12">
            <label for="vehicleRestrictions">{{$t('orders.vehicle_restriction.title')}}</label>
            <v-checkbox v-for="vehicleRestriction in vehicleRestrictions" :key="vehicleRestriction.value"
              v-model="details.vehicleRestrictions"
              :label="vehicleRestriction.text"
              :value="vehicleRestriction.value"
              hide-details
              color="kazan"
            ></v-checkbox>
        </v-col>
        <v-divider
          class="mx-4"
          vertical
        ></v-divider>
        <v-col cols="12" md="4" sm="12">
          <label for="cargoRestrictions">{{$t('orders.cargo_restriction.title')}}</label>
          <v-checkbox v-for="cargoRestriction in cargoRestrictions" :key="cargoRestriction.value"
            v-model="details.cargoRestrictions"
            :label="cargoRestriction.text"
            :value="cargoRestriction.value"
            hide-details
            color="kazan"
          ></v-checkbox>
        </v-col>
        <v-divider
          class="mx-4"
          vertical
        ></v-divider>
        <v-col cols="12" md="3" sm="12">
          <label for="locationRestrictions">{{$t('orders.location_restriction.title')}}</label>
          <v-checkbox v-for="locationRestriction in locationRestrictions" :key="locationRestriction.value"
            v-model="details.locationRestrictions"
            :label="locationRestriction.text"
            :value="locationRestriction.value"
            hide-details
            color="kazan"
          ></v-checkbox>
        </v-col>
        <v-divider class="mx-4"></v-divider>
        <!-- <v-col cols="12" sm="12">
          <v-combobox
            outlined
            v-model="details.labels"
            chips
            clearable
            :label="$t('orders.labels')"
            multiple
            hide-details
          >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              @click="select"
              @click:close="remove(item)"
            >
              <strong>{{ item }}</strong>&nbsp;
            </v-chip>
          </template>
          </v-combobox>
        </v-col> -->
        <v-col cols="12" sm="12">
          <v-textarea
            outlined
            name="comment"
            :label="$t('orders.transport_comment')"
            v-model="details.comment"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'TransportFormDetails',
  props: {
    value: Object
  },
  data () {
    return {
      // cargoRestrictions: [
      //   { value: 'CooledAboveZero', text: this.$i18n.t('orders.cargo_restirction.CooledAboveZero') },
      //   { value: 'FrozenGoods', text: this.$i18n.t('orders.cargo_restirction.FrozenGoods') },
      //   { value: 'DangerousGoods', text: this.$i18n.t('orders.cargo_restirction.DangerousGoods') },
      //   { value: 'ContainsLiIon', text: this.$i18n.t('orders.cargo_restirction.ContainsLiIon') }
      // ],
      // vehicleRestrictions: [
      //   { value: 'HydraulicFront', text: this.$i18n.t('orders.vehicle_restirction.HydraulicFront') },
      //   { value: 'HydraulicArm', text: this.$i18n.t('orders.vehicle_restirction.HydraulicArm') },
      //   { value: 'Tipper', text: this.$i18n.t('orders.vehicle_restirction.Tipper') },
      //   { value: 'SlidingFloor', text: this.$i18n.t('orders.vehicle_restirction.SlidingFloor') },
      //   { value: 'AntiSlipFloor', text: this.$i18n.t('orders.vehicle_restirction.AntiSlipFloor') }
      // ],
      // locationRestrictions: [
      //   { value: 'HYDRAULIC_RAMP', text: this.$i18n.t('orders.location_restirction.HYDRAULIC_RAMP') },
      //   { value: 'FORKLIFT', text: this.$i18n.t('orders.location_restirction.FORKLIFT') },
      //   { value: 'PALLET_TRUCK', text: this.$i18n.t('orders.location_restirction.PALLET_TRUCK') },
      //   { value: 'CRANE', text: this.$i18n.t('orders.location_restirction.CRANE') }
      // ],
      // reasons: [
      //   { value: 'reason_non_standart_address', text: this.$i18n.t('orders.reason_non_standart_address') },
      //   { value: 'reason_customer', text: this.$i18n.t('orders.reason_customer') },
      //   { value: 'reason_complaint', text: this.$i18n.t('orders.reason_complaint') },
      //   { value: 'reason_stand', text: this.$i18n.t('orders.reason_stand') },
      //   { value: 'reason_not_in_time', text: this.$i18n.t('orders.reason_not_in_time') },
      //   { value: 'reason_not_standart', text: this.$i18n.t('orders.reason_not_standart') },
      //   { value: 'reason_standart', text: this.$i18n.t('orders.reason_standart') },
      //   { value: 'reason_missing_material', text: this.$i18n.t('orders.reason_missing_material') },
      //   { value: 'reason_machine', text: this.$i18n.t('orders.reason_machine') },
      //   { value: 'reason_other', text: this.$i18n.t('orders.reason_other') }
      // ],
      details: JSON.parse(JSON.stringify(this.value))
    }
  },
  computed: {
    ...mapState(['signedInCompany']),
    ...mapGetters([
      'getTransportVehicleEquipment',
      'getTransportCargoRestrictions',
      'getTransportLocationEquipment'
    ]),
    cargoRestrictions () {
      return this.getTransportCargoRestrictions.map((value) => {
        return { value, text: this.$i18n.t(`orders.cargo_restriction.${value}`) }
      })
    },
    vehicleRestrictions () {
      return this.getTransportVehicleEquipment.map((value) => {
        return { value, text: this.$i18n.t(`orders.vehicle_restriction.${value}`) }
      })
    },
    locationRestrictions () {
      return this.getTransportLocationEquipment.map((value) => {
        return { value, text: this.$i18n.t(`orders.location_restriction.${value}`) }
      })
    }
  },
  methods: {
    ...mapActions({
      setTransportEnums: 'setTransportEnums'
    }),
    remove (item) {
      this.details.labels.splice(this.details.labels.indexOf(item), 1)
      this.details.labels = [...this.details.labels]
    },
  },
  watch: {
    details: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    this.setTransportEnums()
    if (this.details.cargoDescription === '') {
      this.details.cargoDescription = 'normal'
    }
  }
}
</script>

<style scoped lang="scss">
  .who-pay {
      margin-top: 5px;
  }
  .v-expansion-panel {
    box-shadow: none;
    background: transparent;
  }
  ::v-deep .v-expansion-panel__body {
    padding-left: 20px;
    padding-bottom: 20px;
  }
  ::v-deep .v-expansion-panel__header {
    padding-left: 0 !important;
    color: #006c70;
  }
  ::v-deep .v-expansion-panel__header__icon i{
    color: #006c70 !important;
  }

  .tr-details {
    &.disabled {
      ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
        background-color: #ededed;

        .v-input__append-inner {
          display: none;
        }
      }
      ::v-deep .theme--light.v-input--is-disabled .v-label, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
        color: rgba(0, 0, 0, 0.87);
      }
      ::v-deep input {
        color: rgba(0, 0, 0, 0.87);
      }
      ::v-deep .v-select__selection {
        color: rgba(0, 0, 0, 0.87);
      }
    }
  }

  .disabled-field {
    background-color: #ededed;
    -webkit-box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    padding: 16px 12px;
    border-radius: 2px;
    cursor: text;
    display: flex;
    margin-bottom: 28px;
    font-size: 16px;
    line-height: 16px;
    min-height: 48px;
  }
</style>
